module.exports = __webpack_public_path__ + "img/18a001-04.00958911.png";